"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "arrowHeight", {
  enumerable: true,
  get: function get() {
    return _Arrow.arrowHeight;
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ThemeProvider = require("../../../theme/ThemeProvider");

var _Arrow = _interopRequireWildcard(require("./Arrow.style"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _ThemeProvider.createUseStyles)(_Arrow["default"]);

var Arrow = function Arrow(_ref) {
  var _cx;

  var className = _ref.className,
      _ref$arrowOffset = _ref.arrowOffset,
      arrowOffset = _ref$arrowOffset === void 0 ? 0 : _ref$arrowOffset,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["className", "arrowOffset", "placement", "style"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });
  return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({}, rest, {
    style: _objectSpread(_objectSpread({}, style), {}, (0, _defineProperty2["default"])({}, ['top', 'bottom'].includes(placement) ? 'left' : 'bottom', "".concat(50 + arrowOffset / 2, "%"))),
    className: (0, _classnames["default"])(classes.Arrow, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.Top, placement === 'top'), (0, _defineProperty2["default"])(_cx, classes.Left, placement === 'left'), (0, _defineProperty2["default"])(_cx, classes.Right, placement === 'right'), (0, _defineProperty2["default"])(_cx, classes.Bottom, placement === 'bottom'), _cx), className)
  }));
};

var _default = Arrow;
exports["default"] = _default;
//# sourceMappingURL=Arrow.js.map